"use client";

import Link from "next/link";
import { Typography } from "../ui/typography";
import { useEffect, useState } from "react";
import { ChevronRight, X } from "react-feather";
import { useMetaPixel } from "@/hooks/analytics/use-meta-pixel";

export const TrainerAttention = () => {
	const [isVisible, setIsVisible] = useState(false);
	useMetaPixel();

	// get visibility from local storage
	// If dismissed more than 1 week ago, show again
	useEffect(() => {
		const storedVisibility = localStorage.getItem("trainerAttention");
		if (storedVisibility) {
			const { dismissedAt } = JSON.parse(storedVisibility);
			const oneWeek = 7 * 24 * 60 * 60 * 1000;
			if (Date.now() - dismissedAt > oneWeek) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		} else {
			setIsVisible(true);
		}
	}, []);

	const setIsVisibleAndStore = (visible: boolean) => {
		setIsVisible(visible);
		if (!visible) {
			localStorage.setItem(
				"trainerAttention",
				JSON.stringify({ dismissedAt: Date.now() })
			);
		}
	};

	const handleClose = () => {
		setIsVisibleAndStore(false);
	};

	if (!isVisible) {
		return null;
	}

	return (
		<div className="trainer-attention">
			<div className="trainer-attention__header">
				<Typography variant="title">
					Are you a personal trainer or gym owner?
				</Typography>

				<div className="trainer-attention__close" onClick={handleClose}>
					<X color="white" size={24} />
				</div>
			</div>

			<div className="trainer-attention__text">
				<Typography variant="body">
					See how ApolloFit can help you grow your business. Find new clients,
					create workout plans, schedule sessions, communicate with clients and
					track progress all in one place.
				</Typography>
			</div>
			<Link href="/trainers" className="trainer-attention__link">
				<Typography variant="button">
					Learn More <ChevronRight />
				</Typography>
			</Link>
		</div>
	);
};
